export const COMPANY_NAME = "TURNMEUP CREDIT";
export const COMPANY_SHORT = "Turnmeup Credit";
export const COMPANY_INITIALS = "TC";
export const COMPANY_ADDRESS_FULL = "1710 Maxwell Ln Unit A, Corona, California, US 92881-3215";
export const COMPANY_LOCATION = "Corona, CA";
export const COMPANY_REGION = "California";
export const MAP_URL = "https://www.google.com/maps/search/?api=1&query=1710%20Maxwell%20Ln%20Unit%20A%2C%20Corona%2C%20California%2C%20US%2092881-3215";
export const ABOUT_IMAGE_URL = "https://images.unsplash.com/photo-1497032628192-86f99bcd76bc?auto=format&fit=crop&w=1600&q=80";

export const PROFILE_FACTS = [
  { "label": "Organization", "value": "Turnmeup Credit" },
  { "label": "Region", "value": "California" },
  { "label": "Location", "value": "Corona, CA" },
];

export const PUBLIC_INFO = [
  { "label": "Organization", "value": "TURNMEUP CREDIT" },
  { "label": "City / State", "value": "Corona, CA" },
  { "label": "Address", "value": "1710 Maxwell Ln Unit A, Corona, California, US 92881-3215" },
];

export const CARE_PILLARS = [
  { "icon": "◐", "title": "TODO: Pillar 1", "body": "TODO: Customize." },
  { "icon": "✦", "title": "TODO: Pillar 2", "body": "TODO: Customize." },
  { "icon": "✿", "title": "TODO: Pillar 3", "body": "TODO: Customize." },
  { "icon": "❍", "title": "TODO: Pillar 4", "body": "TODO: Customize." },
];
